import { useQuery } from "@tanstack/react-query";
import { axiosHandler } from "../lib/utils";
import { useSelector } from "react-redux";

const key = "teams";

export const useGetTeams = () => {
  const state = useSelector((state) => state);

  const query = useQuery({
    queryKey: [key],
    queryFn: () =>
      axiosHandler({ url: "teams", state }).then((res) => res.data),
  });

  return query;
};
